/* eslint-disable camelcase */

import { Attribute } from "./hvsBase";

export interface WorkflowActionInfo extends Record<string, unknown> {
  action_name: string;
  action_display_name: string;
  attributes: Record<string, Attribute>;
}

export enum ActionParameters {
  emailTemplateId = "email_template_id",
  useHtml = "use_html",
  to = "to",
  cc = "cc",
  bcc = "bcc",
}
export enum ActionAttributeTypes {
  Subject = "subject",
  Body = "body",
  Email = "email",
  Id = "id",
  Number = "number",
}
export enum ActionNames {
  CreateIncident = "CreateIncident",
  NotificationEmail = "notificationhub.email",
  NotificationPush = "notificationhub.push",
  NotificationSms = "notificationhub.sms",
}
export const useWorkflowActions = (): WorkflowActionInfo[] => [
  {
    action_name: ActionNames.NotificationEmail,
    action_display_name: "Notification - Email",
    attributes: {
      [ActionAttributeTypes.Subject]: {
        appearance: undefined,
        label: "Subject",
        Property: null,
        type: "text",
        value: "",
        order: 1,
      },
      [ActionAttributeTypes.Body]: {
        appearance: undefined,
        label: "Message Body",
        type: "text",
        value: "",
        order: 2,
      },
      [ActionAttributeTypes.Email]: {
        appearance: undefined,
        label: "Recipient Email Address",
        type: "array",
        value: {
          _t: "Newtonsoft.Json.Linq.JArray, Newtonsoft.Json, Version=12.0.0.0, Culture=neutral, PublicKeyToken=30ad4fe6b2a6aeed",
          _v: [],
        },
        order: 3,
      },
    },
  },
];
